import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Skills from './components/Skills';
import Qualification from './components/Qualification';
import Project from './components/Project';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Portfolio from './components/Portfolio';


function App() {
/*==================== SHOW SCROLL UP ====================*/ 
function scrollUp(){
  const scrollUp = document.getElementById('scroll-up');
  // When the scroll is higher than 200 viewport height, add the show-scroll class to the a tag with the scroll-top class
  if(this.scrollY >= 200) scrollUp.classList.add('show-scroll'); else scrollUp.classList.remove('show-scroll')
}
window.addEventListener('scroll', scrollUp)




  return (
    <>
      <Navbar/>
      <main className="main">
          <Home/>
          <About/>
          <Skills/>
          <Qualification/>
          <Portfolio/>
          <Project/>
          <Contact/>
      </main>
      <Footer/>
      <a  href="#home" className="scrollup" id="scroll-up"> <i className="uil uil-arrow-up scrollup__icon"></i>
        </a>
    </>
  );
}

export default App;
